import React, { useState, useEffect } from 'react'
import {
  FileUploadDialog,
  RecentProjects,
  AllProjects,
  PopUpDialog,
  CompsProjectsExplorer,
  AllMapProjects
} from '@components/custom'
import {
  Button,
  Divider,
  LinearProgress,
  Paper,
  Tabs,
  Tab
} from '@material-ui/core'
import { xlsx, normalize } from '@engine/dependencies'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'ramda'
import Comps from '@engine/comps'
import User from '@engine/user'
import PropTypes from 'prop-types'
import './Dashboard.scss'
import CircularProgress from '@material-ui/core/CircularProgress'
import Snackbar from '@material-ui/core/Snackbar'
import { CompsError } from '@compsError'
import { Loading } from '@components/common'
import Property from '@engine/property'
export function Dashboard(props) {
  const [isOpen, onToggle] = useState(false)
  const [snackBarOpen, snackBarOpenToggle] = useState(false)
  const [openDialog, dialogOpenToggle] = useState(false)
  const [projectDetails, setProjectDetails] = useState({})
  const reader = new FileReader()

  useEffect(() => {
    reader.abort()
    props.getRecentProjects()
    props.getAllProjects()
    props.loadRegions()
    snackBarOpenToggle(false)
  }, [])

  useEffect(
    () => {
      if (props.status) {
        snackBarOpenToggle(true)
      }
    },
    [props.status]
  )

  useEffect(
    () => {
      if (props.isPropertyDataReady) {
        props.history.push('/preview')
      } else if (props.isPropImagesNotLoaded) {
        props.dropRejectHandler(
          true,
          'Property images are unable to load from docstore, Please contact Comps support team '
        )
      }
    },
    [props.isPropertyDataReady, props.isPropImagesNotLoaded]
  )

  const fileFormatValidation = fileType => {
    const fileValidFlag = fileType === 'xlsx' || fileType === 'xls'
    if (!fileValidFlag) {
      props.dropRejectHandler(
        true,
        'Inappropriate file format, please upload XLSX file'
      )
    }

    return fileValidFlag
  }

  const handleScroll = event => {
    if (
      event.target.scrollHeight -
        event.target.scrollTop -
        event.target.clientHeight <
      1
    ) {
      if (
        !props.isMapsSelected &&
        ((props.recentPagination.offset + 1) * props.recentPagination.limit <=
          props.recentCount &&
          props.activeTabIndex === 1)
      ) {
        props.setRecentPagination({ offset: props.recentPagination.offset + 1 })
        props.getRecentProjects()
      } else if (
        !props.isMapsSelected &&
        ((props.pagination.offset + 1) * props.pagination.limit <=
          props.count &&
          props.activeTabIndex === 0)
      ) {
        props.setPagination({ offset: props.pagination.offset + 1 })
        props.getAllProjects()
      } else if (
        props.isMapsSelected &&
        (props.mapsPagination.offset + 1) * props.mapsPagination.limit <=
          props.totalMapsCount
      ) {
        props.setMapsPagination({ offset: props.mapsPagination.offset + 1 })
        props.getMapProjects()
      }
    }
  }

  const fileDataValidation = propertyData => {
    let fileDataValidFlag = false
    if (propertyData.Summary && propertyData.Summary.length >= 2) {
      let subjectproptyCount = 0
      let comparableproptyCount = 0
      let totalAverageCount = 0
      propertyData.Summary.forEach(propty => {
        if (
          propty.propertyType.toString().includes('S') ||
          propty.propertyType.toString().includes('s')
        ) {
          subjectproptyCount += 1
        } else if (propty.propertyType === 'NA' && propty.name === 'NA') {
          totalAverageCount += 1
        } else {
          comparableproptyCount += 1
        }
      })
      fileDataValidFlag =
        subjectproptyCount === 1
          ? comparableproptyCount >= 1 && totalAverageCount <= 2
          : comparableproptyCount > 1 && totalAverageCount <= 2
    }

    return fileDataValidFlag
  }

  const parseData = file => {
    let propertyData = {}

    return new Promise((resolve, reject) => {
      reader.onerror = () => {
        reader.abort()
        reject(new DOMException('Problem parsing input file.'))
      }

      reader.onload = event => {
        try {
          const workbook = xlsx.parseCompSheet(event.target.result)
          propertyData = normalize.normalizeWorkbookData(workbook)
          resolve(propertyData)
        } catch (error) {
          if (error instanceof CompsError) {
            props.dropRejectHandler(true, error.message)
          } else {
            props.dropRejectHandler(
              true,
              'Unable to process your request, please reach out to Technical team.'
            )
          }
        }
      }
      if (file instanceof Blob) {
        reader.readAsArrayBuffer(file)
      }
    })
  }

  const dropSuccessHandler = async res => {
    if (res && fileFormatValidation(res.fileType)) {
      const propertyInfo = await parseData(res.file)
      const fileName = res.file.name.substring(
        0,
        res.file.name.lastIndexOf('.')
      )
      if (propertyInfo && fileDataValidation(propertyInfo)) {
        props.setComps({
          propertyInfo,
          fileName,
          barChartData: propertyInfo.barChartData,
          fpBarChartData: propertyInfo.fpBarChartData,
          fpSummaryData: propertyInfo.fpSummaryData,
          templateName: propertyInfo.templateName
        })
      } else {
        props.dropRejectHandler(
          true,
          'Subject and/or Comparable property and/or Total/Weighted is missing in Summary Page'
        )
      }
    }
  }

  const handleCloseSnackbar = () => {
    snackBarOpenToggle(false)
  }

  const onDeleteProject = deleteProjectDetails => {
    setProjectDetails(deleteProjectDetails)
    dialogOpenToggle(true)
  }

  const cancelDeleteDialog = () => {
    dialogOpenToggle(false)
    setProjectDetails({})
  }

  const onSelectFavorite = favoriteObj => {
    props.setProjectAsFavorite(favoriteObj)
  }

  const onDelete = () => {
    props.deleteProject(projectDetails)
    dialogOpenToggle(false)
    snackBarOpenToggle(true)
  }

  const toggleProjects = (event, newValue) => {
    props.setTabIndex({ tabValue: newValue })
  }

  const getPopupInformation = deleteProjectName => ({
    delete: {
      title: 'Delete?',
      cancelMessage: 'CANCEL',
      confirmMessage: 'DELETE',
      popUpDialogmessage: `Are you sure you want to delete the Project "${deleteProjectName}" permanently?`,
      canceleDialog: cancelDeleteDialog,
      discardDialog: onDelete
    }
  })

  return (
    <React.Fragment>
      <Loading isLoading={props.listLoading}>
        {props.loading && <LinearProgress />}
        <div className="db-container">
          <div className="left-nav">
            <Button
              data-testid="create-comps-button"
              className="btn-create"
              onClick={() => onToggle(!isOpen)}
            >
              <span className="plusIcon">&#43;</span>
              <span className="create-button-text">CREATE NEW</span>
            </Button>
            <CompsProjectsExplorer
              getAllProjects={props.getAllProjects}
              searchProjects={props.searchProjects}
              getRecentProjects={props.getRecentProjects}
              setRecentPagination={props.setRecentPagination}
              setPagination={props.setPagination}
              regions={props.regions}
              setTotalProjectsText={props.setTotalProjectsText}
              favoriteUserId={props.entityUserGuid}
              getMapProjects={props.getMapProjects}
              setMapsPagination={props.setMapsPagination}
            />
          </div>
          {isOpen && (
            <FileUploadDialog
              open={isOpen}
              close={() => {
                onToggle(false)
                props.dropRejectHandler(false)
                props.resetSelectedListInfo()
                props.resetListSearchResults()
              }}
              errorOnFileDrop={props.errorOnFileDrop}
              dropRejectHandler={props.dropRejectHandler}
              onDropSuccess={dropSuccessHandler}
            />
          )}

          <div
            className="projects-content"
            data-testid="comps-content"
            onScroll={handleScroll}
          >
            {props.isMapsSelected && (
              <div className="all-projects-content">
                <AllMapProjects
                  mapProjects={props.mapProjects}
                  totalMapsCount={props.totalMapsCount}
                />
                {props.fetchProjectLoading && (
                  <div className="loadMore">
                    <CircularProgress />
                    <span> Loading More Projects</span>
                  </div>
                )}
              </div>
            )}
            {!props.isMapsSelected && (
              <>
                <div>
                  <div className="comps-projects-title">
                    Your Recent Projects {props.isMapsSelected}
                  </div>
                  <Divider />
                  <br />
                </div>
                <div className="recent-projects-content">
                  <RecentProjects
                    favoriteClick={props.favoriteClick}
                    history={props.history}
                    recentProjects={props.recentProjects}
                    userId={props.entityUserGuid}
                    deleteProject={onDeleteProject}
                    onSelectFavorite={onSelectFavorite}
                  />
                </div>
                <Divider className="all-projects-divider" />
                <Paper square className="dashboard-paper">
                  <Tabs
                    indicatorColor="primary"
                    textColor="primary"
                    aria-label="subject comparable tabs"
                    onChange={toggleProjects}
                    value={props.activeTabIndex}
                    className="dashboard-tabs"
                    data-testid="projects-tab-selection"
                  >
                    <Tab label="All Projects" className="dashboard-tab-label" />
                    <Tab label="My Projects" className="dashboard-tab-label" />
                  </Tabs>
                  {props.activeTabIndex === 0 ? (
                    <div className="all-projects-content">
                      <AllProjects
                        favoriteClick={props.favoriteClick}
                        history={props.history}
                        allProjects={props.allProjects}
                        count={props.count}
                        userId={props.entityUserGuid}
                        deleteProject={onDeleteProject}
                        totalProjectsText={props.totalProjectsText}
                        onSelectFavorite={onSelectFavorite}
                      />
                      {props.fetchProjectLoading && (
                        <div className="loadMore">
                          <CircularProgress />
                          <span> Loading More Projects</span>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="all-projects-content">
                      <AllProjects
                        favoriteClick={props.favoriteClick}
                        history={props.history}
                        allProjects={props.recentProjects}
                        count={props.recentCount}
                        userId={props.entityUserGuid}
                        deleteProject={onDeleteProject}
                        totalProjectsText={props.totalProjectsText}
                        onSelectFavorite={onSelectFavorite}
                      />
                      {props.fetchRecentProjectLoading && (
                        <div className="loadMore">
                          <CircularProgress />
                          <span> Loading More Projects</span>
                        </div>
                      )}
                    </div>
                  )}
                </Paper>
              </>
            )}
          </div>

          {openDialog && (
            <PopUpDialog
              title={getPopupInformation().delete.title}
              cancelMessage={getPopupInformation().delete.cancelMessage}
              confirmMessage={getPopupInformation().delete.confirmMessage}
              popUpDialogmessage={
                getPopupInformation(projectDetails.projectName).delete
                  .popUpDialogmessage
              }
              popUpDialogOpen={openDialog}
              canceleDialog={getPopupInformation().delete.canceleDialog}
              discardDialog={getPopupInformation().delete.discardDialog}
            />
          )}
          {props.status && (
            <Snackbar
              data-testid="snackbar-project-deleted"
              anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
              className="snackbar-deleted"
              open={snackBarOpen}
              onClose={handleCloseSnackbar}
              autoHideDuration={5000}
              message={props.status}
            />
          )}
        </div>
      </Loading>
    </React.Fragment>
  )
}

Dashboard.propTypes = {
  entityUserGuid: PropTypes.string,
  setComps: PropTypes.func,
  dropRejectHandler: PropTypes.func,
  errorOnFileDrop: PropTypes.shape({
    errorOnDrop: PropTypes.bool,
    errorMessage: PropTypes.string
  }),
  history: PropTypes.shape({
    push: PropTypes.func
  }),
  isPropertyDataReady: PropTypes.bool,
  isPropImagesNotLoaded: PropTypes.bool,
  recentProjects: PropTypes.array,
  getRecentProjects: PropTypes.func,
  loading: PropTypes.bool,
  listLoading: PropTypes.bool,
  allProjects: PropTypes.array,
  count: PropTypes.number,
  getAllProjects: PropTypes.func,
  getMapProjects: PropTypes.func,
  fetchProjectLoading: PropTypes.bool,
  fetchRecentProjectLoading: PropTypes.bool,
  pagination: PropTypes.object,
  recentPagination: PropTypes.object,
  setRecentPagination: PropTypes.func,
  setPagination: PropTypes.func,
  deleteProject: PropTypes.func,
  status: PropTypes.string,
  searchProjects: PropTypes.func,
  loadRegions: PropTypes.func,
  regions: PropTypes.array,
  setTotalProjectsText: PropTypes.func,
  totalProjectsText: PropTypes.string,
  setProjectAsFavorite: PropTypes.func,
  favoriteClick: PropTypes.bool,
  listInfoLoading: PropTypes.string,
  resetSelectedListInfo: PropTypes.func,
  resetListSearchResults: PropTypes.func,
  activeTabIndex: PropTypes.number,
  setTabIndex: PropTypes.func,
  recentCount: PropTypes.number,
  isMapsSelected: PropTypes.bool,
  mapProjects: PropTypes.array,
  recentMapProjects: PropTypes.array,
  totalMapsCount: PropTypes.number,
  mapPageNo: PropTypes.number,
  mapsPagination: PropTypes.object,
  setMapsPagination: PropTypes.func
}

const mapDispatchToProps = {
  setComps: Comps.actions.setComps,
  getRecentProjects: Comps.actions.getRecentProjects,
  getAllProjects: Comps.actions.getAllProjects,
  getMapProjects: Comps.actions.getMapProjects,
  setRecentPagination: Comps.actions.setRecentPagination,
  setMapsPagination: Comps.actions.setMapsPagination,
  setPagination: Comps.actions.setPagination,
  deleteProject: Comps.actions.deleteProject,
  searchProjects: Comps.actions.searchProjects,
  loadRegions: Comps.actions.loadRegions,
  setTabIndex: Comps.actions.setTabIndex,
  setTotalProjectsText: Comps.actions.setTotalProjectsText,
  setProjectAsFavorite: Comps.actions.setProjectAsFavorite,
  resetSelectedListInfo: Comps.actions.resetSelectedListInfo,
  resetListSearchResults: Property.actions.resetListSearchResults
}

const mapStateToProps = state => ({
  entityUserGuid: User.selectors.user.entityUserGuid(state),
  isPropertyDataReady: state.comps.comps.isPropertyDataReady,
  isPropImagesNotLoaded: state.comps.comps.isPropImagesNotLoaded,
  recentProjects: state.comps.comps.recentProjects,
  loading: Comps.selectors.network.isLoading(
    state,
    Comps.constants.SEARCH_PROJECTS.ACTION
  ),
  listLoading: Comps.selectors.network.isLoading(
    state,
    Comps.constants.CREATE_PROJECT_FROM_LIST.ACTION
  ),
  allProjects: state.comps.comps.allProjects,
  count: state.comps.comps.count,
  recentCount: state.comps.comps.recentCount,
  fetchProjectLoading: state.comps.comps.fetchProjectLoading,
  fetchRecentProjectLoading: state.comps.comps.fetchRecentProjectLoading,
  pagination: state.comps.comps.pagination,
  recentPagination: state.comps.comps.recentPagination,
  status: Comps.selectors.comps.status(state),
  regions: Comps.selectors.comps.regions(state),
  activeTabIndex: state.comps.comps.activeTabIndex,
  totalProjectsText: Comps.selectors.comps.totalProjectsText(state),
  favoriteClick: state.comps.comps.favoriteClick,
  listInfoLoading: Comps.selectors.comps.listInfoLoading(state),
  isMapsSelected: Comps.selectors.comps.isMapsSelected(state),
  mapProjects: state.comps.comps.mapProjects,
  recentMapProjects: state.comps.comps.recentMapProjects,
  totalMapsCount: state.comps.comps.totalMapsCount,
  mapPageNo: state.comps.comps.mapPageNo,
  mapsPagination: state.comps.comps.mapsPagination
})

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Dashboard)
